var map = {
	"./badge_challenge_1.png": 484,
	"./badge_health_1.png": 485,
	"./badge_highfive_1.png": 486,
	"./badge_level_1_1.png": 487,
	"./badge_level_2_1.png": 488,
	"./badge_level_3_1.png": 489,
	"./badge_level_4_1.png": 490,
	"./badge_level_5_1.png": 491,
	"./badge_level_6_1.png": 492,
	"./badge_money_1.png": 493,
	"./badge_share_1.png": 494,
	"./badge_support_1.png": 495,
	"./badge_supporting_1.png": 225
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges ^\.\/badge_.*_1\.png$
// module id = 483
// module chunks = 0